import React, { useState, useEffect } from 'react';
import "./LatestNewsPost.css";
import { Avatar } from "@material-ui/core";
import FavoriteRoundedIcon from "@material-ui/icons/FavoriteRounded";
import { db } from "../firebase";
import firebase from "firebase";

function LatestNewsPost({ LNId, photoURL, username, imageUrl, caption, likes }) {
    const [likeInIcon, setLikeInIcon] = useState("iconLight");
    const user = firebase.auth().currentUser;

    useEffect(() => {
        db.collection("latestNews").doc(LNId).collection("postLikes").doc(user?.uid).get().then((doc) => {
            if (doc.data()) {
                if (likeInIcon === "iconLight") {
                    setLikeInIcon("iconLight blue")
                } else {
                    setLikeInIcon("iconLight")
                }
            }
        })
    }, [likeInIcon, LNId, user?.uid])

    const handleLike = (e) => {
        e.preventDefault();
        if (likeInIcon === "iconLight") {
            setLikeInIcon("iconLight red")

        } else {
            setLikeInIcon("iconLight")
        }
        db.collection("latestNews").doc(LNId).get().then((doc2) => {
            const data = doc2.data();
            console.log(likeInIcon)
            if (likeInIcon === "iconLight") {
                db.collection("latestNews").doc(LNId).collection("postLikes").doc(user.uid).get().then((doc3) => {
                    if (doc3.data()) {
                        console.log(doc3.data())
                    } else {
                        db.collection("latestNews").doc(LNId).collection("postLikes").doc(user.uid).set({
                            likes: 1
                        });
                        db.collection("latestNews").doc(LNId).update({
                            likes: data.likes + 1
                        })
                    }
                })
            } else {
                db.collection("latestNews").doc(LNId).collection("postLikes").doc(user.uid).delete().then(function () {
                    db.collection("latestNews").doc(LNId).update({
                        likes: data.likes - 1
                    })
                })
            }
        })
    }

    return (
        <div className="LNPosts">
            <div className="LNPosts__header">
                <Avatar src={photoURL} />
                <h4>{username}</h4>
            </div>
            <div className="LNPosts__post">
                <p>{caption}</p>
                {/* eslint-disable-next-line  */}
                <img src={imageUrl} alt="For some issues, you can't view this photo." />
            </div>
            <div className="LNPosts__footer">
                <FavoriteRoundedIcon className={likeInIcon} onClick={handleLike} />
                <p>{likes}</p>
            </div>
        </div>
    )
}

export default LatestNewsPost;